function RakeRaceInfo({content}) {
    return <div className="rake-race-info" dangerouslySetInnerHTML={{__html: content}} />
}
export default RakeRaceInfo